const publicUrl = process.env.PUBLIC_URL ?? "";

/** Stable paths for large hero media in public/ (not bundled by webpack). */
export const HOME_INTRO_VIDEOS = {
  desktop: `${publicUrl}/videos/video-intro-desktop.mp4`,
  mobile: `${publicUrl}/videos/video-intro-mobile.mp4`,
} as const;

/** Matches useBreakpoint: mobile is width < BREAKPOINTS.tablet (768px). */
export const HOME_INTRO_VIDEO_MEDIA = {
  mobile: `(max-width: ${768 - 1}px)`,
  desktop: `(min-width: 768px)`,
} as const;
